import React from 'react';
import {Card, CardActions, CardHeader, CardMedia, CardText, CardTitle, Chip, FlatButton, Paper, RaisedButton} from "material-ui";


export default class LandingPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            carouselIndex: 0
        }
    }

    componentDidMount() {
        // this.carousel();
    }

    carousel = () => {
        let i;
        const x = document.getElementsByClassName("carouselSlides");
        for (i = 0; i < x.length; i++) {
            x[i].style.display = "none";
        }

        let index = this.state.carouselIndex;
        index++;
        if (index > x.length) {
            index = 1
        }
        x[index - 1].style.display = "block";

        let titleText = '';
        switch (index) {
            case 1:
                titleText = "1";
                break;
            case 2:
                titleText = "2";
                break;
        }

        this.setState({
            title: titleText,
            carouselIndex: index
        }, () => {
            setTimeout(this.carousel, 5000);
        });

    };

    render() {
        return (
            <div style={{
                paddingBottom: 32,
                width: '100%',
                height: '100%',
            }}>

                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingBottom: 16}}>

                    <RaisedButton
                        href="/login"
                        backgroundColor={'blue'}
                        primary
                        label={"Login"}
                        style={{color: 'white'}}
                    />
                </div>

                <Card className="container" style={{textAlign: 'center', padding: '16px'}}>
                    <CardTitle
                        title={<strong>SISTEM PENTRU OPTIMIZAREA PRECESELOR<br/>DE ACHIZIȚIE PUBLICĂ</strong>}
                        subtitle={<strong>Achizițiile publice devin simple cu un soft potrivit. Simplificăm procesul achizițiilor publice printr-o platformă
                            online, accesibilă de oriunde.</strong>}
                    />

                </Card>

                <Card
                    className="container"
                    style={{
                        marginTop: 16,
                        padding: 16,
                        paddingBottom: 32,
                        textAlign: 'center',
                        display: 'inline-block',
                    }}
                >

                    <CardTitle
                        title="Ce oferim?"
                    />

                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginRight: 16}}>
                        <div>
                            <Chip
                                style={{width: '100%', padding: 4}}
                            >
                                Un soft accesibil online, de oriunde
                            </Chip>

                            <Chip
                                style={{width: '100%', padding: 4, marginTop: 8}}
                            >
                                Realizarea și generarea referatelor de necesitate
                            </Chip>

                            <Chip
                                style={{width: '100%', padding: 4, marginTop: 8}}
                            >
                                Filtrarea referatelor de necesitate după anumite criterii
                            </Chip>
                        </div>

                        <div style={{marginLeft: 16}}>
                            <Chip
                                style={{width: '100%', padding: 4}}
                            >
                                Sistem de aprobare a referatelor ușor și online
                            </Chip>


                            <Chip
                                style={{width: '100%', padding: 4, marginTop: 8}}
                            >
                                Generarea de rapoarte privind situația achizițiilor
                            </Chip>

                            <Chip
                                style={{width: '100%', padding: 4, marginTop: 8}}
                            >
                                La cerere adăugăm și alte functionalități
                            </Chip>
                        </div>
                    </div>
                </Card>

                <Card className="container" style={{padding: '16px', marginTop: 16, textAlign: 'center'}}>

                    <CardTitle
                        title="Instituții care au ales platforma noastră"
                    />

                    <div>
                        <a href="http://operacluj.ro/">
                            <img style={{marginTop: 16}}
                                 src={'./pictures/logo_opera.png'}
                            />
                        </a>

                    </div>
                </Card>

                <Card className="container" style={{padding: '16px', marginTop: 16}}>
                    <CardTitle
                        title="CONTACT"
                    />
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <div>
                            <i style={{display: 'inline-block', verticalAlign: 'middle'}} className="material-icons">local_phone</i>
                            <strong style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: 4}}>0746 490 768</strong>
                        </div>
                        <div>
                            <i style={{display: 'inline-block', verticalAlign: 'middle'}} class="material-icons">contact_mail</i>
                            <strong style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: 4}}>clpstudio@outlook.com</strong>
                        </div>
                    </div>
                </Card>

                <Card
                    className="container"
                    style={{
                        marginTop: 32,
                        textAlign: 'center',
                    }}
                >
                    <CardTitle
                        title={<strong>Exemplu de utilizare</strong>}
                    />

                </Card>

                <Card className="container" style={{marginTop: 16}}>
                    <CardHeader
                        title="Exemplu creare referat"
                    />
                    <CardMedia>
                        <img src={'./pictures/create_paper.png'} alt=""/>
                    </CardMedia>
                    <CardTitle
                        title="Cum se crează un referat de necesitate?"
                        subtitle="Orice șef de departament poate crea un referat și să îl trimită spre aprobarea superiorilor"
                    />
                    <CardText>
                        Orice șef de departament poate crea un referat de necesitate. Referatul trebuie să conțină justificarea achiziției, categoria
                        de achiziție, sursa de finanțare, și un articol care trebuie selectat dintr-o listă a instituției. Un referat poate fi trimis spre
                        aprobare sau
                        salvat pentru o modificare ulterioară
                    </CardText>
                </Card>

                <Card className="container" style={{marginTop: 16}}>
                    <CardHeader
                        title="Exemplu aprobare referat"
                    />
                    <CardMedia>
                        <img src={'./pictures/approve_1.png'} alt=""/>
                    </CardMedia>
                    <CardTitle
                        title="Cum se aprobă un referat de necesitate?"
                        subtitle="Directorul economic, managerul sau biroul de achiziții publice pot aproba un referat de necesitate"
                    />
                    <CardText>
                        Persoanele care au anumite funcții pot aproba un referat de necesitate. În cazul acesta un referat trebuie aprobat de Directorul
                        Economic,
                        Managerul instituției și reprezentantul Biroului de achiziții.
                    </CardText>
                </Card>

                <Card className="container" style={{marginTop: 16}}>
                    <CardHeader
                        title="Lista de referate și starea lor"
                    />
                    <CardMedia>
                        <img src={'./pictures/see_all.png'} alt=""/>
                    </CardMedia>
                    <CardTitle
                        title="Lista referatelor și starea lor"
                        subtitle="Persoanele din procesul de aprobare pot vedea toate referatele create de angajații instituției"
                    />
                    <CardText>
                        Referatele și starea lor de aprobare poate fi verificată online. Persoanele din procesul de aprobare pot vedea toate referatele
                        instituției, iar ceilalți angajați pot vedea doar referatele create de ei, fară a avea acces la referatele colegilor.
                    </CardText>
                </Card>

                <Card className="container" style={{marginTop: 16}}>
                    <CardHeader
                        title="Exemplu referat generat"
                    />
                    <CardMedia>
                        <img src={'./pictures/print_paper.png'} alt=""/>
                    </CardMedia>
                    <CardTitle
                        title="După aprobare un referat poate fi generat și printat la imprimantă pentru semnare și ștampilare"
                    />
                </Card>

                <Card className="container" style={{marginTop: 16}}>
                    <CardHeader
                        title="Lista articolelor cumpărate"
                    />
                    <CardMedia>
                        <img src={'./pictures/article_details_list.png'} alt=""/>
                    </CardMedia>
                    <CardTitle
                        title="După aprobare articolele referatului intră în lista produselor cumpărate"
                        subtitle="După ce un produs este cumpărat se poate introduce datele contabile si recepția. Orice produs cumpărat va intra
                        în raportul de situație al achizițiilor pe anul respectiv"
                    />
                </Card>

                <Card className="container" style={{marginTop: 16}}>
                    <CardHeader
                        title="Informații adiționale în urma achiziției produsului"
                    />
                    <CardMedia>
                        <img src={'./pictures/article_details.png'} alt=""/>
                    </CardMedia>
                    <CardTitle
                        title="După ce produsul a fost cumpărat efectiv se pot introduce datele contabile și recepția"
                    />
                </Card>

                <Card className="container" style={{marginTop: 16}}>
                    <CardHeader
                        title="Raportul priving situația achizițiilor in format tabelar"
                    />
                    <CardMedia>
                        <img src={'./pictures/acquisitions_report.png'} alt=""/>
                    </CardMedia>
                    <CardTitle
                        title="Tabelul priving achizițiile pe o anumită perioada: an sau intervale lunare"
                        subtitle="După cce au fost introduse informațiile adiționale în urma cumpărarii, articolul este introdus în situația privind achizițiile publice"
                    />
                </Card>

            </div>
        )
    }

}